import type { Cta, NavigationItem } from '@/types/content'
import { ROUTE_KEYS } from '@/i18n/routing'

/**
 * Résout un lien de contenu (venant du back-office) vers une destination
 * utilisable par <Link>. Les liens internes référencent une CLÉ de route :
 * le chemin traduit est calculé, jamais stocké en dur.
 */
export function resolveHref(link: Cta | NavigationItem) {
  if (link.externalUrl) {
    return { external: true as const, href: link.externalUrl }
  }

  if (!link.routeKey) {
    return { external: true as const, href: '#' }
  }

  const pathname = ROUTE_KEYS[link.routeKey]
  return {
    external: false as const,
    href: link.query ? { pathname, query: link.query } : pathname,
  }
}
